export const FETCH_ALERTS = 'FETCH_ALERTS';
export const STORE_ALERTS = 'STORE_ALERTS';
export const FETCH_ALERT_SUMMARY = 'FETCH_ALERT_SUMMARY';
export const STORE_ALERT_SUMMARY = 'STORE_ALERT_SUMMARY';
export const RESOLVE_ALERT = 'RESOLVE_ALERT';
export const DELETE_ALL_ALERTS = 'DELETE_ALL_ALERTS';

// Window event Base.jsx fires when the server pushes 'refreshAlerts' over
// the socket. Base owns the socket and dispatches the alert fetch itself;
// this lets Alerts.jsx refresh the access-request queue on the same signal
// without duplicating the owner-tier guard that decides whether asking for
// it is even safe.
export const ALERTS_CHANGED_EVENT = 'app:alerts-changed';
